<template>
  <div>
    <h1>404 Not Found</h1>
    <p>The requested page could not be found.</p>
  </div>
</template>
